<template>
  <div class="user-history infinite-list-page">
    <!-- <h2 class="history-title">我的观看历史</h2> -->
    <!-- <el-divider></el-divider> -->

    <div class="infinite-list-page__body">
      <div class="infinite-list-page__content">
        <div v-if="loading && displayHistory.length === 0" class="infinite-initial-loading">
          加载中...
        </div>

        <!-- 阅读记录列表 -->
        <div v-else-if="displayHistory.length > 0" class="history-list">
          <div
            v-for="history in displayHistory"
            :key="history.id"
            class="history-item"
            @click="continueReading(history)"
          >
            <img :src="history.cover" alt="漫画封面" class="history-cover" />
            <div class="history-info">
              <h3 class="history-name">{{ history.name }}</h3>
              <!-- 漫画主题 -->
              <div class="history-themes" v-if="history.themes && history.themes.length > 0">
                <span class="theme-dot"></span>
                <span class="theme-text">
                  {{ history.themes.join(' / ') }}
                </span>
              </div>
              <p class="history-progress">观看进度：{{ formatProgress(history.progressTotal) }}</p>
              <el-button
                type="primary"
                class="history-btn"
                @click.stop="continueReading(history)"
              >
                继续阅读
              </el-button>
            </div>
          </div>
        </div>

        <!-- 无阅读记录 -->
        <div v-else class="empty-history">
          <el-empty description="暂无观看历史"></el-empty>
        </div>

        <div
          v-if="isMobile && displayHistory.length > 0"
          ref="historySentinel"
          class="infinite-sentinel"
          aria-hidden="true"
        />
        <p v-if="isMobile && loadingMore" class="infinite-loading-hint">加载中...</p>
      </div>
      <div
        v-if="showInfiniteEndTip"
        class="infinite-list-page__spacer"
        aria-hidden="true"
      />
    </div>

    <p v-if="showInfiniteEndTip" class="infinite-end-tip">
      <span class="infinite-end-tip-text">我也是有底线的</span>
    </p>

    <!-- 分页（仅桌面端） -->
    <div v-if="!isMobile && totalItems > 0" class="pagination">
      <button
        class="page-button"
        @click="previousPage"
        :disabled="currentPage === 1"
      >
        上一页
      </button>
      <span class="page-info">
        第 {{ currentPage }} 页 / 共 {{ totalPages }} 页（共 {{ totalItems }} 条）
      </span>
      <button
        class="page-button"
        @click="nextPage"
        :disabled="currentPage === totalPages"
      >
        下一页
      </button>
    </div>
  </div>
</template>

<script setup>
import { useUserHistory } from '@/features/user/composables/useUserHistory'

const {
  loading,
  loadingMore,
  isMobile,
  historySentinel,
  displayHistory,
  showInfiniteEndTip,
  currentPage,
  totalPages,
  totalItems,
  continueReading,
  formatProgress,
  nextPage,
  previousPage,
} = useUserHistory()
</script>

<style scoped src="@/features/user/styles/operationArea/UserHistory.css"></style>
<style scoped src="@/features/user/styles/operationArea/OperationAreaTheme.css"></style>
